import { createTheme } from '@mui/material'
import { default as baseTheme } from 'shared/style/theme'

const theme = createTheme(baseTheme, {
    palette: {
        greyscale: {
            white: '#fff',
            grey_100: '#C6C6C6',
            black: '#000',
        },
        primary: {
            main: '#007BC7',
            light: '#DBEDFF',
            dark: '#00456F',
        },
        other: {
            primary_50: '#E1F6FF',
            primary_100: '#0288D1', // doesn't have a name in figma but used in task button
            focus_dark: 'rgba(0, 0, 0, 0.12)', // comes from mui menu but needs to be reused
            outlinedBorder: 'rgba(0, 110, 209, 0.50)', // named color from figma in "add additional graduate degree" button
            secondary_light: 'rgba(0, 0, 0, 0.6)',
        },
        secondary: {
            main: '#006ED1',
            outlinedBorder: 'rgba(0, 110, 209, 0.50)', // named color from figma in "add additional graduate degree" button
            dark: '#001d33',
        },
        info: {
            main: '#0288D1',
        },
        success: {
            main: '#42BE65',
        },
    },
    fontSize: {
        xsmall: '0.75rem',
    },
    components: {
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#B2D3F1',
                    color: '#001D33',
                },
            },
        },
    },
})

export default theme
